export default __webpack_public_path__ + "static/submittable-logo__color-fde2ba33c7339e72ac49ed6bd08ce1c8.svg";